import { LotacaoEditableTableModel } from 'components/form/editable-table/LotacaoEditableTable'
import {
  AtividadeColetivaGruposVisualizarQuery,
  AtividadeColetivaGrupoTableQuery,
  PageParams,
  TipoGrupoParticipanteAtividadeColetivaEnum,
} from 'graphql/types.generated'

import { EquipeSelectModel, UnidadeSaudeSelectModel } from '../../../components/form'
import { CidadaoEditableTableModel } from './CidadaoEditableTable'

export const QUANTIDADE_INTEGRANTES_GRUPO_SAUDE_TOOLTIP =
  'Soma da quantidade de profissionais e participantes envolvidos na atividade'
export const QUANTIDADE_INTEGRANTES_GRUPO_REUNIAO_TOOLTIP = 'Quantidade de profissionais envolvidos na atividade'

export interface AtividadeColetivaGruposFilterPopperFormModel {
  unidadesSaude?: UnidadeSaudeSelectModel[]
  equipes?: EquipeSelectModel[]
  tipoGrupo?: TipoGrupoParticipanteAtividadeColetivaEnum
  showOnlyInativos?: boolean
}

export type AtividadeColetivaGruposFilterFormModel = AtividadeColetivaGruposFilterPopperFormModel & {
  nomeGrupo?: string
  isSomenteRegistrosProprios: boolean
  pageParams?: PageParams
}

export interface AtividadeColetivaGruposFormModel {
  id?: ID
  nome: string
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  lotacoesEnvolvidas?: LotacaoEditableTableModel[]
  cidadaosParticipantes?: CidadaoEditableTableModel[]
}

export interface AtividadeColetivaGruposTableModel {
  id: ID
  nome: string
  tipoGrupo: string
  quantidadeIntegrantes: number
  unidadeSaude: string
  equipesEnvolvidas: string
  ativo: boolean
}

export type AtividadeColetivaGruposContentType = AtividadeColetivaGrupoTableQuery['gruposParticipantesAtividadeColetiva']['content'][0]

export interface AtividadeColetivaGruposInputModel {
  isAtivo: boolean
  tipoGrupo: TipoGrupoParticipanteAtividadeColetivaEnum
  equipesIds: string[]
  unidadesSaudeIds: string[]
  nomeGrupo: string
  isSomenteMeusGrupos: boolean
  pageParams: PageParams
}

export const atividadeColetivaTipoGrupoRecord: Record<TipoGrupoParticipanteAtividadeColetivaEnum, string> = {
  REUNIAO: 'Reunião',
  ATIVIDADE_EM_SAUDE: 'Atividade em saúde',
}

export type AtividadeColetivaGruposModel = AtividadeColetivaGruposVisualizarQuery['grupoParticipanteAtividadeColetiva']

export type CidadaoParticipante = AtividadeColetivaGruposModel['cidadaosParticipantes'][0]
